export default __webpack_public_path__ + "static/media/blog-img215.3eabd86c.jpg";